import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useContext, useEffect, useRef, useState } from "react";
import Popper from "components/Popper";
import { ITag } from "dto/ITag";
import classNames from "classnames";
import TagBadge from "components/TagBadge";
import tagsService from "api/tagsService";
import ChooseTagNew from "components/ChooseTagNew";
import { Tooltip } from "@mui/material";
import { ItemKind } from "dto/IKindItems";
import IssuesContext from "contexts/IssuesContext";
import { useTranslation } from "react-i18next";

const TagCell: FC<Props> = ({ element, tags }) => {
  const { t } = useTranslation();
  const refTag = useRef(null);
  const { issues, setIssues } = useContext(IssuesContext);
  const { mutate: removeTag } = tagsService.useRemoveTagFromPackage();
  const [showTagsSmall, setShowTagsSmall] = useState(false);

  const [findedTags, setFindedTags] = useState<ITag[]>([]);

  useEffect(() => {
    const t = tags?.filter((tag) =>
      element?.TagIds?.find((iTag) => tag.Id === iTag)
    );

    setFindedTags(t);
  }, [element?.TagIds, tags]);

  const handleUpdateTags = (tags: ITag[]) => {
    const newIssues = [...issues];

    const el = newIssues.find((c) => c.Id === element.Id);

    if (el) {
      el.TagIds = tags.map((t) => t.Id);
    }

    setIssues(newIssues);
  };

  const handleRemoveTag = (tag: ITag) => {
    removeTag(
      {
        OwnerId: element.Id,
        OwnerKind: ItemKind.Issue,
        TagId: tag.Id,
      },
      {
        onSuccess: () => {
          setFindedTags(findedTags.filter((ftag) => ftag.Id !== tag.Id));
        },
      }
    );
  };

  return (
    <div
      className={classNames(
        styles.tags,
        findedTags && findedTags.length > 0 ? styles.notEmpty : styles.empty
      )}
      ref={refTag}
    >
      {findedTags.map((tag) => (
        <div onClick={() => setShowTagsSmall(!showTagsSmall)}>
          <TagBadge
            onRemove={(tag) => handleRemoveTag(tag)}
            tag={tag}
            key={`tag_${element.Id}_${tag.Id}`}
          />
        </div>
      ))}

      {findedTags && findedTags.length === 0 && (
        <Tooltip title={t("common.setLabel")}>
          <div>
            <div
              className={styles.fakeBadge}
              onClick={(e) => {
                setShowTagsSmall(!showTagsSmall);
                e.stopPropagation();
              }}
            >
              ...
            </div>
          </div>
        </Tooltip>
      )}

      {showTagsSmall && (
        <Popper
          anchorEl={refTag?.current}
          open={showTagsSmall}
          setOpen={setShowTagsSmall}
        >
          <ChooseTagNew
            toggle={setShowTagsSmall}
            updateTags={handleUpdateTags}
            //@ts-ignore
            toTag={element as IPackage}
          />
        </Popper>
      )}
    </div>
  );
};

export default TagCell;
